import classNames from "classnames";

import { setData } from "rivals/shared/utils/qa";
import PageHeader from "./PageHeader";
import styles from "./PageWithTopSection.module.scss";
import type { Props } from "./types";

export enum BODY_BACKGROUNDS {
  WHITE = "white",
  GRAY = "gray"
}

const bodyBackgroundsMap = {
  [BODY_BACKGROUNDS.WHITE]: styles.white,
  [BODY_BACKGROUNDS.GRAY]: styles.gray
};

const PageWithTopSection = ({
  children,
  className = "",
  data = "",
  isBodyCentered = true,
  topSection,
  bodyBackground = BODY_BACKGROUNDS.GRAY
}: Props): JSX.Element => {
  const top = (
    <div className={styles.topSection}>
      <div>{topSection}</div>
    </div>
  );

  const body = (
    <div
      className={classNames(styles.body, {
        [styles.centered]: isBodyCentered
      })}
    >
      <div>{children}</div>
    </div>
  );

  return (
    <div
      className={classNames(
        styles.container,
        bodyBackgroundsMap[bodyBackground],
        className
      )}
      {...setData(data, "container")}
    >
      {top}
      {body}
    </div>
  );
};

PageWithTopSection.PageHeader = PageHeader;

export default PageWithTopSection;
